import { saveWindowState } from './windows';
import { sendPostRequest } from './utils';
import { addAlert, addLocalStorageAlert } from './alerts';

// --- Helper Functions ---

/**
 * Handles API errors by displaying an alert and logging the error.
 * @param {Error} error - The error object.
 * @param {string} defaultMessage - The default error message from gettext.
 * @param {string} consoleMessage - The message to log to the console.
 */
const handleApiError = (error, defaultMessage, consoleMessage) => {
    const message = error.response?.data?.message || defaultMessage;
    addAlert('error', message);
    console.error(consoleMessage, error);
};

/**
 * Closes the station window and its parent modal.
 * @param {HTMLElement} stationWindow - The station window element.
 */
const closeStationWindow = (stationWindow) => {
    stationWindow.classList.remove('window-open');
    const modal = stationWindow.closest('.window-modal');
    if (modal) {
        modal.classList.remove('window-modal-open');
    }
    saveWindowState(stationWindow);
};

// --- Event Handlers ---

/**
 * Handles the logic for selecting a station.
 * @param {HTMLElement} stationButton - The clicked station button.
 * @param {HTMLElement} selectedStationDisplay - The element to display the selected station name.
 * @param {HTMLElement} stationWindow - The main station window element.
 */
const handleStationSelection = async (
    stationButton,
    selectedStationDisplay,
    stationWindow,
) => {
    const { stationId, stationLabel } = stationButton.dataset;
    try {
        await sendPostRequest('/api/utils/set-station', {
            station_id: stationId,
        });
        selectedStationDisplay.textContent = stationLabel;
        closeStationWindow(stationWindow);
    } catch (error) {
        handleApiError(
            error,
            gettext('Nie udało się wybrać stanowiska. Spróbuj ponownie.'),
            'Error setting station',
        );
    }
};

/**
 * Handles the station synchronization with external API (Enova).
 * @param {HTMLElement} btn - The sync button element.
 */
const handleStationSync = async (btn) => {
    if (btn.disabled) return;

    const originalText = btn.innerText;

    btn.disabled = true;
    btn.style.opacity = '0.7';
    btn.innerText = gettext('Proszę czekać...');

    try {
        await sendPostRequest('/api/utils/sync-stations');
        addLocalStorageAlert(
            'success',
            gettext('Stanowiska zostały zsynchronizowane.'),
        );
        window.location.reload();
    } catch (error) {
        btn.disabled = false;
        btn.style.opacity = '1';
        btn.innerText = originalText;

        handleApiError(
            error,
            gettext('Nie udało się zsynchronizować stanowisk.'),
            'Error syncing stations',
        );
    }
};

// --- Main Execution ---

document.addEventListener('DOMContentLoaded', () => {
    const stationWindow = document.getElementById('stationWindow');
    if (!stationWindow) return;

    const syncBtn = document.getElementById('syncStationsBtn');
    if (syncBtn) {
        syncBtn.addEventListener('click', () => {
            handleStationSync(syncBtn);
        });
    }

    const selectedStation = document.getElementById('selectedStation');
    stationWindow.addEventListener('click', (e) => {
        const stationButton = e.target.closest(
            '.station-button:not(.add-station)',
        );

        if (stationButton) {
            handleStationSelection(
                stationButton,
                selectedStation,
                stationWindow,
            );
        }
    });
});
